<template>
    <div class="contenido">
        <Titulo titulo="NOTICIAS"/>
        <b-container class="detalle-noticia">
            <b-row>
                <!-- el detalle de la noticia -->
                <b-col cols="12" md="8">
                    <Noticia  v-for="noticia in noticias" :key="noticia.id_noticia"
                        :idNoticia="noticia.id_noticia"
                        :titulo="noticia.noticia"
                        :descripcion="noticia.contenido"
                        :imagen="noticia.imagen"
                    />
                </b-col>
                <b-col cols="12" md="4">
                    <div>
                        <b-tabs content-class="mt-3 mb-0">
                            <b-tab title="Noticias recientes" active>
                                <b-container>
                                    <MiniNoticia v-for="reciente in noticiasRecientes" :key="reciente.id_noticia"
                                        :idNoticia="reciente.id_noticia"
                                        :fecha="reciente.ffeccap"
                                        :titulo="reciente.noticia"
                                        :imagen="reciente.imagen"
                                    />
                                </b-container>
                            </b-tab>
                            <b-tab title="Lo más visto">
                                <b-container>
                                    <MiniNoticia v-for="masVista in noticiasMasVistas" :key="masVista.id_noticia"
                                        :idNoticia="masVista.id_noticia"
                                        :fecha="masVista.ffeccap"
                                        :titulo="masVista.noticia"
                                        :imagen="masVista.imagen"
                                    />
                                </b-container>
                            </b-tab>
                        </b-tabs>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import Titulo from '@/components/Titulo.vue'
import Noticia from '@/components/Noticia.vue'
import MiniNoticia from '@/components/MiniNoticia.vue'
import axios from 'axios'
import {mapState} from 'vuex'

export default {
    name: 'Noticias',
    props: {
    },
    components: {
        Titulo, Noticia, MiniNoticia
    },
    data() {
        return {
            noticias: [],
            noticiasRecientes: [],
            noticiasMasVistas: []
        }
    },
    created() {
        this.traerNoticias()
        this.traerRecientes()
        this.traerMasVistas()
    },
    methods: {
        zfill(number, width) {
            var numberOutput = Math.abs(number); /* Valor absoluto del número */
            var length = number.toString().length; /* Largo del número */ 
            var zero = "0"; /* String de cero */  
            
            if (width <= length) {
                if (number < 0) {
                    return ("-" + numberOutput.toString()); 
                } else {
                    return numberOutput.toString(); 
                }
            } else {
                if (number < 0) {
                    return ("-" + (zero.repeat(width - length)) + numberOutput.toString()); 
                } else {
                    return ((zero.repeat(width - length)) + numberOutput.toString()); 
                }
            }
        },
        traerNoticias() {
            // traemos las noticias mas recientes
            var formData = new FormData();
            formData.append("accion", "mostrarDatos");
            formData.append("tabla", "vnoticias");
            formData.append("filtro", `vigencia >='${this.hoy}'`);
            formData.append("ordenamiento", `id_noticia desc`);
            
            axios.post(`${this.url}/ajax/ajax.generico.php`, formData)
            .then((res) => {
                this.noticias = res.data
            });
        },
        traerRecientes() {
            var formData = new FormData();
            formData.append("accion", "mostrarDatos");
            formData.append("tabla", "vnoticias");
            formData.append("filtro", `vigencia >=${this.hoy}`);
            formData.append("ordenamiento", `id_noticia desc`);
            formData.append("limite", 5);
            
            axios.post(`${this.url}/ajax/ajax.generico.php`, formData)
            .then((res) => {
                this.noticiasRecientes = res.data
            });
        },
        traerMasVistas() {
            var formData = new FormData();
            formData.append("accion", "mostrarDatos");
            formData.append("tabla", "vnoticias");
            formData.append("ordenamiento", `visitas desc`);
            formData.append("limite", 5);
            
            axios.post(`${this.url}/ajax/ajax.generico.php`, formData)
            .then((res) => {
                this.noticiasMasVistas = res.data
            });
        }
    },
    computed: {
        hoy() {
            var fecha = new Date();
            var dia = fecha.getDate();

            var mes = fecha.getMonth();
            mes ++;
            
            var anio = fecha.getFullYear();
            
            return anio + '-' + this.zfill(mes, 2) + '-' + this.zfill(dia, 2);
        },
        url() {
            if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
                return this.urlSandbox
            } else {
                return this.urlProd
            }
        },
        ...mapState(['urlProd']),
        ...mapState(['urlSandbox'])
    }
}
</script>

<style scoped>
.contenido{
    min-height: 500px;
}
</style>